import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
  } from 'chart.js';
  import { Doughnut, Pie } from 'react-chartjs-2';
  import TitleCard from '../Cards/TitleCard';
  
  ChartJS.register(CategoryScale, LinearScale, ArcElement, Title, Tooltip, Legend);
  
  function DistributionChart() {

    const labels = ['Airdrop', 'Founders and Team', 'Development', 'Initial Investors', 'Advisors, Legal and PR ', 'Overdraft Reserves'];
  
    const options = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      responsive: true,
      
      title: {
        display: false,
        text: "Distribution Chart",
      },
      tooltips: {
        mode: "index",
        intersect: false,
      },
      hover: {
        mode: "nearest",
        intersect: true,
      },
      legend: {
        labels: {
          fontColor: "rgba(0,0,0,.4)",
        },
        align: "end",
        position: "bottom",
      }, 
    }; 

    const data = {
      labels,
      datasets: [
        {
          label: 'Token Distribution',
          backgroundColor: [
            '#FBF5C9',
            '#5E17EB',
            '#C1FF72',
            '#D9D9D9',
            '#FBF5C9',
            '#004AAD'
          ],
          borderColor: [
            '#FBF5C9',
            '#5E17EB',
            '#C1FF72',
            '#D9D9D9',
            '#FBF5C9',
            '#004AAD'
          ],
          
          data: [12, 11.25, 5, 42.50, 5.25, 24],
          fill: false,
          barThickness: 8,
          borderWidth: 1,
        }, 
      ],
    };
  
    return (
      <TitleCard title={"Token Distribution"}>
        <Doughnut redraw='true' options={options} data={data} style={{position:'relative', height:'64vh',  width:'96vw'}} />
      </TitleCard>
  
    )
  }
  //position: relative; height:40vh; width:80vw
  
  export default DistributionChart